'use client'
import React, { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import Script from 'next/script'

import * as fbq from './fpixel'

const FacebookPixelHead = () => {
  return (
    <noscript>
      <img
        height='1'
        width='1'
        style={{ display: 'none' }}
        src={`https://www.facebook.com/tr?id=${fbq.FB_PIXEL_ID}&ev=PageView&noscript=1`}
      />
    </noscript>
  )
}

const FacebookPixel = () => {
  const [loaded, setLoaded] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    if (!loaded) return

    fbq.pageview()
  }, [pathname, loaded])

  return (
    <div>
       <Script
        id='fb-pixel'
        strategy='afterInteractive'
        onLoad={() => setLoaded(true)}
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', ${fbq.FB_PIXEL_ID});
          `,
        }}
      />
    </div>
  )
}

export {FacebookPixelHead, FacebookPixel}